// extracted by mini-css-extract-plugin
module.exports = {"environments":"style_environments__2qyvQ"};